export default __webpack_public_path__ + "static/bg2-h-1e70949d62991f79c599438a67a813c5.jpg";